import API from "@/services/api";
import { FetchSettingsResponse } from "../types/settings";

export enum Endpoints {
	FetchSettings = "/ov_customize/ov_settings",
	FetchUserSettings = "/ov_customize/ov_private_settings"
}

const fetchUserSettings = () => {
  return new Promise<FetchSettingsResponse>(async (resolve, reject) => {
    API.get<FetchSettingsResponse>({
      endpoint: Endpoints.FetchUserSettings,
      versions: [2]
    })
    .then(res => {
      resolve(res.promise.data);
    })
    .catch(err => {
      reject(err);
    })
  })
}

const fetchSettings = () => {
	return new Promise<FetchSettingsResponse>(async (resolve, reject) => {
		API.get<FetchSettingsResponse>({
			endpoint: Endpoints.FetchSettings,
      versions: [2]
		})
		.then(res => {
			resolve(res.promise.data);
		})
		.catch(err => {
			reject(err);
		})
	})
}

export default {
	fetchSettings,
	fetchUserSettings
};
